
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M20.47 5.62999C20.86 6.01999 20.86 6.63999 20.47 7.02999L9.13 18.37C8.74 18.76 8.12 18.76 7.73 18.37L3.53 14.17C3.14 13.78 3.14 13.16 3.53 12.77C3.92 12.38 4.54 12.38 4.93 12.77L8.43 16.27L19.07 5.62999C19.46 5.23999 20.08 5.23999 20.47 5.62999ZM18.36 3.50999L8.43 13.44L5.64 10.65C4.86 9.86999 3.59 9.86999 2.81 10.65L1.41 12.05C0.629997 12.83 0.629997 14.1 1.41 14.88L7.01 20.48C7.79 21.26 9.06 21.26 9.84 20.48L22.59 7.73999C23.37 6.95999 23.37 5.68999 22.59 4.90999L21.19 3.50999C20.4 2.72999 19.14 2.72999 18.36 3.50999Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-done-outline`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconDoneOutline

    ```js
    <b-new-b-icon-done-outline />
    ```
</docs>


